function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 7.81v3.44h-5.25V2.03c3.3.2 5.25 2.33 5.25 5.78zm0 4.94v3.44c0 3.45-1.95 5.58-5.25 5.78v-9.22H22zm-14.75 0v9.22C3.95 21.77 2 19.64 2 16.19v-3.44h5.25zm0-10.72v9.22H2V7.81c0-3.45 1.95-5.58 5.25-5.78zm8-.03h-6.5v9.25h6.5V2zm0 10.75h-6.5V22h6.5v-9.25z"
})));